var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3V21.0006M3 4.20004H20.4006C20.5162 4.20017 20.6293 4.23368 20.7263 4.29654C20.8233 4.35941 20.9001 4.44896 20.9474 4.55442C20.9947 4.65988 21.0106 4.77677 20.9931 4.89103C20.9755 5.00528 20.9254 5.11205 20.8486 5.19848L17.6445 8.80021C17.4491 9.01992 17.3411 9.30376 17.3411 9.59783C17.3411 9.89191 17.4491 10.1757 17.6445 10.3955L20.8446 13.9996C20.9214 14.086 20.9715 14.1928 20.9891 14.307C21.0066 14.4213 20.9907 14.5382 20.9434 14.6436C20.8961 14.7491 20.8193 14.8387 20.7223 14.9015C20.6253 14.9644 20.5122 14.9979 20.3966 14.998H3",
    stroke: "#1B1B1B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBlack);
export default __webpack_public_path__ + "static/media/flag-black.1bf9c55ab217dacd52240d9d465e9b74.svg";
export { ForwardRef as ReactComponent };